import { ReactComponent as BookingsIcon } from '../bookings.svg'
import { ReactComponent as EngagementIcon } from '../engagement.svg'
import { ReactComponent as GuestIcon } from '../guest.svg'
import styles from './StatsPanel.module.scss'

function StatsPanel({ stats, variant = 'trigger' }) {
  const { guests, engagements, clickThroughRate, emailsSent, textsSent, bookings } = stats

  const isAction = variant === 'action'

  return (
    <div className={styles.statsPanel}>
      <div className={styles.statRow}>
        <GuestIcon className={styles.statIcon} />
        <span className={styles.statValueGuests}>{guests.toLocaleString()} guests</span>
      </div>

      {!isAction && (
        <div className={styles.statRow}>
          <EngagementIcon className={styles.statIcon} />
          <span className={styles.statValueEngagements}>
            {engagements.toLocaleString()} engagements
          </span>
        </div>
      )}

      {isAction && (
        <div className={styles.statRow}>
          <span className={styles.statValueSent}>
            {emailsSent.toLocaleString()} emails, {textsSent.toLocaleString()} texts sent
          </span>
        </div>
      )}

      <div className={styles.statRow}>
        <span className={styles.statValueClickThrough}>
          {clickThroughRate.toFixed(0)}% click through rate
        </span>
      </div>

      {isAction && (
        <div className={styles.bottomGroup}>
          <div className={styles.statRow}>
            <EngagementIcon className={styles.statIcon} />
            <span className={styles.statValueEngagements}>
              {engagements.toLocaleString()} engagements
            </span>
          </div>
          <div className={styles.statRow}>
            <BookingsIcon className={styles.statIcon} />
            <span className={styles.statValueBookings}>
              {bookings.toLocaleString()} bookings
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default StatsPanel
